// removed by extract-text-webpack-plugin
module.exports = {"MainDescr":"MainDescription__MainDescr__-hash-base-64-5-"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/MainDescription/MainDescription.scss
// module id = 182
// module chunks = 0